/* ========================================
   KANCHWALA JEWELLERS
   ======================================== */

let cart = JSON.parse(localStorage.getItem('kanchwala_cart') || '[]');
// let civilIdFiles = [];

const uiCopy = {
  ar: {
    currencyPrefix: '',
    currencySuffix: ' د.ك',
    cartWeight: 'الوزن',
    cartGoldWeight: 'وزن الذهب',
    cartSize: 'المقاس',
    cartQty: 'العدد',
    cartTotalPrice: 'السعر الإجمالي',
    removeItem: 'شيلها',
    uploadChange: 'غيّر الصور',
    preparingOrder: 'دقيقة... قاعدين نجهز طلبك',
    checkoutButton: 'كمّل الطلب',
    alertIntro: 'نسخة تجريبية:',
    alertCivilName: 'اسم البطاقة المدنية',
    alertCivilNumber: 'رقم البطاقة المدنية',
    alertPhone: 'رقم الهاتف',
    alertImages: 'عدد الصور المرفوعة',
    alertConsent: 'الموافقة',
    alertYes: 'نعم',
    alertCartTotal: 'إجمالي السلة',
    alertCheckoutNote: 'بالمتجر الفعلي راح نوديك صفحة الدفع بعد ما نحفظ هالبيانات.',
    langButton: 'English',
    langAria: 'Switch to English'
  },
  en: {
    currencyPrefix: 'KWD ',
    currencySuffix: '',
    cartWeight: 'Weight',
    cartGoldWeight: 'Gold weight',
    cartSize: 'Size',
    cartQty: 'Qty',
    cartTotalPrice: 'Total price',
    removeItem: 'Remove',
    uploadChange: 'Change images',
    preparingOrder: 'One moment... preparing your order',
    checkoutButton: 'Complete order',
    alertIntro: 'Demo preview:',
    alertCivilName: 'Civil ID name',
    alertCivilNumber: 'Civil ID number',
    alertPhone: 'Phone',
    alertImages: 'Uploaded images',
    alertConsent: 'Consent',
    alertYes: 'Yes',
    alertCartTotal: 'Cart total',
    alertCheckoutNote: 'On the live store, this would continue to checkout after saving these details.',
    langButton: 'العربية',
    langAria: 'التبديل إلى العربية'
  }
};

function getCurrentLanguage() {
  return localStorage.getItem('kanchwala_lang') || 'ar';
}

function t(key) {
  const lang = getCurrentLanguage();
  return uiCopy[lang]?.[key] ?? uiCopy.ar[key] ?? key;
}

function localizedValue(value) {
  if (value && typeof value === 'object') {
    return value[getCurrentLanguage()] || value.ar || value.en || '';
  }
  return value || '';
}

function formatKWD(amount) {
  const value = amount.toFixed(3);
  return getCurrentLanguage() === 'en' ? `KWD ${value}` : `${value} د.ك`;
}

function applyLanguage() {
  const lang = getCurrentLanguage();
  const root = document.documentElement;
  root.lang = lang;
  root.dir = lang === 'en' ? 'ltr' : 'rtl';

  document.querySelectorAll('[data-en]').forEach(el => {
    if (!el.hasAttribute('data-ar')) {
      el.setAttribute('data-ar', el.textContent);
    }
    el.textContent = lang === 'en' ? el.getAttribute('data-en') : el.getAttribute('data-ar');
  });

  document.querySelectorAll('[data-en-html]').forEach(el => {
    if (!el.hasAttribute('data-ar-html')) {
      el.setAttribute('data-ar-html', el.innerHTML);
    }
    el.innerHTML = lang === 'en' ? el.getAttribute('data-en-html') : el.getAttribute('data-ar-html');
  });

  document.querySelectorAll('[data-en-placeholder]').forEach(el => {
    if (!el.hasAttribute('data-ar-placeholder')) {
      el.setAttribute('data-ar-placeholder', el.getAttribute('placeholder') || '');
    }
    el.setAttribute('placeholder', lang === 'en' ? el.getAttribute('data-en-placeholder') : el.getAttribute('data-ar-placeholder'));
  });

  document.querySelectorAll('[data-en-aria]').forEach(el => {
    if (!el.hasAttribute('data-ar-aria')) {
      el.setAttribute('data-ar-aria', el.getAttribute('aria-label') || '');
    }
    el.setAttribute('aria-label', lang === 'en' ? el.getAttribute('data-en-aria') : el.getAttribute('data-ar-aria'));
  });

  document.querySelectorAll('[data-en-title]').forEach(el => {
    if (!el.hasAttribute('data-ar-title')) {
      el.setAttribute('data-ar-title', el.textContent);
    }
    el.textContent = lang === 'en' ? el.getAttribute('data-en-title') : el.getAttribute('data-ar-title');
  });

  document.querySelectorAll('[data-lang-toggle]').forEach(el => {
    el.textContent = t('langButton');
    el.setAttribute('aria-label', t('langAria'));
  });

  const uploadChange = document.querySelector('.kanchwala-upload-change');
  if (uploadChange) uploadChange.textContent = t('uploadChange');

  const checkoutBtn = document.getElementById('kanchwalaCheckoutBtn');
  if (checkoutBtn && checkoutBtn.style.pointerEvents !== 'none') {
    checkoutBtn.textContent = t('checkoutButton');
  }
}

function kanchwalaToggleLanguage() {
  const next = getCurrentLanguage() === 'ar' ? 'en' : 'ar';
  localStorage.setItem('kanchwala_lang', next);

  const currentPath = window.location.pathname;

  if (next === 'en') {
    // Add /en/ prefix if not already there
    if (!currentPath.startsWith('/en/') && currentPath !== '/en') {
      const newPath = '/en' + (currentPath === '/' ? '/' : currentPath);
      window.location.href = newPath;
    }
  } else {
    // Strip /en/ prefix for Arabic (default)
    if (currentPath.startsWith('/en/')) {
      const newPath = currentPath.replace('/en/', '/') || '/';
      window.location.href = newPath;
    } else if (currentPath === '/en' || currentPath === '/en/') {
      window.location.href = '/';
    } else {
      applyLanguage();
      renderCart?.();
    }
  }

  // applyLanguage();
  // renderCart();
}

window.kanchwalaToggleLanguage = kanchwalaToggleLanguage;

function saveCart() {
  localStorage.setItem('kanchwala_cart', JSON.stringify(cart));
}

function updateCartCount() {
  const count = cart.reduce((sum, item) => sum + item.qty, 0);
  document.querySelectorAll('#kanchwalaCartCount').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

const colorClasses = [
  'kanchwala-product-card__image--gold-1',
  'kanchwala-product-card__image--gold-2',
  'kanchwala-product-card__image--gold-3',
  'kanchwala-product-card__image--gold-4',
  'kanchwala-product-card__image--gold-5',
];


function animateCartButton() {
  const btn = document.querySelector('.kanchwala-header__cart-btn');
  if (!btn) return;
  btn.style.transform = 'scale(1.3)';
  setTimeout(() => { btn.style.transform = 'scale(1)'; }, 300);
}

function kanchwalaToggleMobileMenu() {
  const menu = document.getElementById('kanchwalaMobileMenu');
  if (menu) {
    menu.classList.toggle('active');
    document.body.style.overflow = menu.classList.contains('active') ? 'hidden' : '';
  }
}

window.kanchwalaToggleMobileMenu = kanchwalaToggleMobileMenu;

window.addEventListener('scroll', () => {
  const header = document.querySelector('.kanchwala-header');
  if (header) {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    // closeCart();
    kanchwalaCloseCart();
    const menu = document.getElementById('kanchwalaMobileMenu');
    if (menu) menu.classList.remove('active');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  applyLanguage();
//   renderCart();
  updateCartCount();
});

// function kanchwalaToggleWeightSummary () {
//   document.getElementById('kanchwalaWeightBreakdown').classList.toggle('open');
// }


// ========================================
// PRODUCT PAGE FUNCTIONS
// ========================================

// Gallery functions
window.kanchwalaChangeGalleryImage = function(imageUrl, element) {
  const mainImage = document.getElementById('kanchwalaMainGallery');
  if (mainImage) {
    mainImage.style.background = 'url(' +  imageUrl + ') center/cover';
  }
  document.querySelectorAll('.kanchwala-product-gallery__thumb').forEach(thumb => {
    thumb.classList.remove('active');
  });
  element.classList.add('active');
};

// Add touch/swipe support for mobile
let touchStartX = 0;
let touchEndX = 0;

const galleryMain = document.getElementById('kanchwalaMainGallery');
if (galleryMain){
galleryMain.addEventListener('touchstart', (e) => {
  // console.log('hii');  
  touchStartX = e.changedTouches[0].screenX;
});

galleryMain.addEventListener('touchend', (e) => {
  // console.log('hello');
  touchEndX = e.changedTouches[0].screenX;
  handleSwipe();
});
}
function handleSwipe() {
  // console.log('swipe');
  const thumbs = document.querySelectorAll('.kanchwala-product-gallery__thumb');
  const currentActive = document.querySelector('.kanchwala-product-gallery__thumb.active');
  let currentIndex = Array.from(thumbs).indexOf(currentActive);
  
  if (touchEndX < touchStartX - 50) {
    // Swipe left - next image
    currentIndex = (currentIndex + 1) % thumbs.length;
  } else if (touchEndX > touchStartX + 50) {
    // Swipe right - previous image
    currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
  }
  
  if (currentIndex !== Array.from(thumbs).indexOf(currentActive)) {
    const imageUrl = thumbs[currentIndex].style.backgroundImage.match(/url\(['"]?([^'"]+)['"]?/)[1];
    kanchwalaChangeGalleryImage(imageUrl, thumbs[currentIndex]);
  }
}

// Weight breakdown toggle
window.kanchwalaToggleWeightSummary = function() {
  const breakdown = document.getElementById('kanchwalaWeightBreakdown');
  if (breakdown) {
    breakdown.classList.toggle('open');
  }
};


// Quantity functions
window.kanchwalaChangeQty = function(change) {
  const qtyInput = document.getElementById('kanchwalaProductQty');
  if (qtyInput) {
    let newQty = parseInt(qtyInput.value) + change;
    if (newQty < 1) newQty = 1;
    if (newQty > 10) newQty = 10;
    qtyInput.value = newQty;
  }
};

// Update cart count from Shopify cart
window.kanchwalaUpdateCartCount = function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const itemCount = cart.item_count;
      document.querySelectorAll('.kanchwala-cart-count, #kanchwalaCartCount').forEach(el => {
        el.textContent = itemCount;
        el.style.display = itemCount > 0 ? 'flex' : 'none';
      });
    })
    .catch(error => console.error('Error fetching cart:', error));
};



// Cart functions using Shopify AJAX API
  
  
  window.kanchwalaAddToCart = function(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(() => {
      window.kanchwalaLoadCart();
      window.kanchwalaOpenCart();
    })
    .catch(error => console.error('Error adding to cart:', error));
  };
  
  
  window.kanchwalaUpdateQuantity = function(lineKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      window.kanchwalaRenderCart(cart);
      window.kanchwalaUpdateCartCount(cart);
    })
    .catch(error => console.error('Error updating quantity:', error));
  };
  
  


  